import React, { FC, useState, useEffect } from "react";
import { loader } from "../..";
import { watchUserLocation } from "../../utils/fetchUserLocation";
import { RentalType } from "../../types";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  GET_LOCK_STATUS,
  GET_RENTALS,
  LOCK_VEHICLE,
  UNLOCK_VEHICLE,
} from "../../apollo/operations";
import { useSelector } from "react-redux";
import { showToast } from "../../utils/showToast";
import { proximity } from "../../assets/images";
import useDistanceCalculator from "../../hooks/useDistanceCalculator";
import { TiCancelOutline } from "react-icons/ti";
import { Loading, RentalCard, RentalChat } from "../../components";
import { isSameDay } from "date-fns";
import { CiWarning } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import ActiveRental from "../../components/dashboard/ActiveRental.Dashboard";
import { formatDateAndTimeFromISO } from "../../utils/formateISOtoDate";

const Trips: FC = () => {
  const user = useSelector((state: any) => state.user.userDetails);

  const headers: string[] = ["Active", "Booked", "History"];

  const [activeHeader, setActiveHeader] = useState<string>(headers[0]);

  const [image, setImage] = useState<string>("");
  const [vehicleLocation, setVehicleLocation] = useState<string>("");
  const [activeRental, setActiveRental] = useState<RentalType>();
  const [readyRental, setReadyRental] = useState<RentalType>();
  const [bookedRental, setBookedRental] = useState<RentalType[]>();
  const [allRental, setAllRental] = useState<RentalType[]>();
  const [tripEndsToday, setTripEndsToday] = useState<boolean>();
  const [showEndTripModal, setShowEndTripModal] = useState<boolean>(false);

  const [userLocation, setUserLocation] = useState<{
    latitude: number;
    longitude: number;
  }>();
  const [vehicleFound, setVehicleFound] = useState<boolean>(true); //TODO: SET TO FALSE
  const [locationAway, setLocationAway] = useState<number>(0);

  const navigate = useNavigate();

  const {
    loading: rentalLoading,

    refetch: rentalRefetch,
  } = useQuery(GET_RENTALS, {
    variables: {
      orderBy: [
        {
          createdAt: "Desc",
        },
      ],
      where: {
        lessee: {
          id: user?.id,
        },
      },
    },
    onCompleted: (data) => {
      // console.log("data.rentals", data.rentals);
      const active: RentalType = data.rentals.find(
        (rental: RentalType) => rental.rentalStatus === "Active"
      );
      setActiveRental(active);
      // console.log(isSameDay(new Date(active.rentalEndDatetime), new Date()));
      if (active) {
        setTripEndsToday(
          isSameDay(new Date(active.rentalEndDatetime), new Date())
        );
        getLockStatus({
          variables: {
            data: {
              vehicleId: active?.car.smartCarVehicleId,
            },
          },
        });
      }

      const ready: RentalType = data.rentals.find(
        (rental: RentalType) =>
          rental.rentalStatus === "Booked" &&
          new Date(rental.rentalStartDatetime) <=
            new Date(new Date().getTime() + 1 * 60 * 60 * 1000)
      );

      if (ready) {
        setReadyRental(ready);
      }

      const booked = data.rentals.filter(
        (rental: RentalType) => rental.rentalStatus === "Booked"
      );
      // console.log("Booked", booked);
      setBookedRental(booked);

      setAllRental(
        data.rentals.filter(
          (rental: RentalType) => rental.rentalStatus !== "Requesting"
        )
      );
    },
    onError: (error) => {
      // console.log(error);

      showToast(error.message, "error");
      // TODO: redirect to login page
      // navigate("/auth");
    },
  });

  watchUserLocation().then((location) => {
    // console.log(location);
    setUserLocation(location);
  });

  const { calculateDistance } = useDistanceCalculator();

  const [getLockStatus] = useLazyQuery(GET_LOCK_STATUS, {
    onCompleted: (data) => {
      console.log(data);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [lockVehicle, { loading: lockLoading }] = useMutation(LOCK_VEHICLE, {
    onCompleted: (data) => {
      // console.log(data);
      // if(data.lockVehicle.status === "success"){
      //   showToast("Vehicle locked successfully", "success");
      // }

      showToast(data.lockVehicle.message, data.lockVehicle.status ?? "info");
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [unlockVehicle, { loading: unlockLoading }] = useMutation(
    UNLOCK_VEHICLE,
    {
      onCompleted: (data) => {
        console.log(data);

        showToast(
          data.unLockVehicle.message,
          data.unLockVehicle.status ?? "info"
        );
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  useEffect(() => {
    if (activeRental && activeRental.car.parkedLocation) {
      let map: google.maps.Map;

      loader.importLibrary("maps").then((google) => {
        map = new google.Map(document.getElementById("mapDiv") as HTMLElement, {
          // center: { lat: 6.5244, lng: 3.3792 },
          center: {
            lat: activeRental.car.parkedLocation.latitude,
            lng: activeRental.car.parkedLocation.longitude,
          },
          zoom: 8,
          mapId: activeRental.id,
        });
      });

      loader.importLibrary("marker").then((google) => {
        const vehicleImg = document.createElement("img");
        vehicleImg.src = ipfsGatewayImage(image);
        vehicleImg.style.width = "80px";
        vehicleImg.style.height = "80px";
        vehicleImg.style.borderRadius = "50%";
        vehicleImg.style.objectFit = "cover";
        vehicleImg.style.objectPosition = "center";
        vehicleImg.style.cursor = "pointer";
        vehicleImg.style.animation = "blinking 2s infinite";
        vehicleImg.style.padding = "10px";
        vehicleImg.style.backgroundColor = "white";
        vehicleImg.style.boxShadow = "0px 0px 10px 0px rgba(0,0,0,0.75)";

        new google.AdvancedMarkerElement({
          position: {
            lat: activeRental.car.parkedLocation.latitude,
            lng: activeRental.car.parkedLocation.longitude,
          },
          map: map,
          title: "Vehicle Location",
          content: vehicleImg,
        });

        new google.AdvancedMarkerElement({
          position: {
            lat: userLocation?.latitude!,
            lng: userLocation?.longitude!,
          },
          map: map,
          title: "Your Location",
          // content: vehicleImg,
        });
      });

      loader.importLibrary("routes").then((google) => {
        const directionsService = new google.DirectionsService();
        const directionsRenderer = new google.DirectionsRenderer();
        directionsRenderer.setMap(map);

        directionsService.route(
          {
            origin: {
              lat: userLocation?.latitude!,
              lng: userLocation?.longitude!,
            },
            destination: {
              lat: activeRental.car.parkedLocation.latitude,
              lng: activeRental.car.parkedLocation.longitude,
            },
            travelMode: google.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              // console.log(response);
              directionsRenderer.setDirections(response);
            } else {
              // window.alert("Directions request failed due to " + status);
            }
          }
        );
      });

      const distance = calculateDistance(
        userLocation?.latitude!,
        userLocation?.longitude!,
        activeRental.car.parkedLocation.latitude,
        activeRental.car.parkedLocation.longitude
      );
      setLocationAway(distance);
      if (distance <= 10) {
        setVehicleFound(true);
      }
    }
  }, [activeRental, image, userLocation]);

  useEffect(() => {
    if (!image && activeRental) {
      // }
      const imgArr = activeRental.car?.carImages?.filter(
        (image) => image.imageUrl
      );
      const imgMap = imgArr.map((image) => image.imageUrl);
      const imgArrs = new Set(imgMap);

      setImage(Array.from(imgArrs)[0]);
    }

    if (!vehicleLocation && activeRental?.car?.parkedLocation) {
      loader.importLibrary("geocoding").then((google) => {
        const geocoder = new google.Geocoder();
        geocoder.geocode(
          {
            location: {
              lat: activeRental.car.parkedLocation.latitude,
              lng: activeRental.car.parkedLocation.longitude,
            },
          },
          (results, status) => {
            if (status === "OK") {
              if (results?.length) {
                setVehicleLocation(results[0].formatted_address);
              } else {
                // window.alert("No results found");
              }
            } else {
              // window.alert("Geocoder failed due to: " + status);
            }
          }
        );
      });
    }
  }, [activeRental?.car, image, vehicleLocation]);

  useEffect(() => {
    rentalRefetch();
  }, []);

  if (rentalLoading || lockLoading || unlockLoading) {
    return (
      <Loading
        loading={rentalLoading || lockLoading || unlockLoading}
        desc={
          rentalLoading
            ? "Fetching your rentals"
            : lockLoading
            ? "Locking vehicle"
            : unlockLoading
            ? "Unlocking vehicle"
            : "Loading"
        }
      />
    );
  }

  return (
    <div className=" w-full ">
      <div className="w-full  bg-white border-t border-t-[#E5E5E5] overflow-scroll hide-scrollbar hide-scrollbar::-webkit-scrollbar">
        <div className="flex w-full mx-3 md:w-[80%]  md:mx-auto gap-5 justify-between items-center py-4 ">
          <div className="flex items-center w-full gap-5">
            {headers.map((header, index) => (
              <div
                key={index}
                onClick={() => setActiveHeader(header)}
                className={`cursor-pointer w-fit text-left whitespace-nowrap p-4 rounded-md border-b border-r border-white/30 text-darkGreen ${
                  activeHeader === header ? "bg-[#CFF1E6] " : "bg-white "
                } `}
              >
                {header} {header !== "History" && "Trips"}
              </div>
            ))}
          </div>
          <div className="flex items-center gap-5">
            <button
              type="button"
              className={`font-Poppins text-center w-fit text-[13px] whitespace-nowrap font-semibold text-white px-7 py-3 border rounded-md bg-midGreen `}
              onClick={() => navigate("/vehicles")}
            >
              Rent a Vehicle
            </button>
            {/* <button
            type="button"
            className="flex items-center gap-2 py-[11px] px-8 md:px-[70px] bg-white border-midGreen rounded-lg text-[#19B375] font-bold text-[12px] leading-[150%]  "
          >
            <BsChatText className=" text-[#19B375] text-[24px]" />
            Chat
          </button> */}
          </div>
        </div>
      </div>

      <div className="w-full min-h-screen bg-white/70 py-[20px] ">
        <div className="w-[90%] md:w-4/5  mx-auto flex flex-col gap-10 ">
          {/* <div className="w-full flex justify-around">
          {headers.map((header, index) => (
            <div
              key={index}
              onClick={() => setActiveHeader(header)}
              className={`cursor-pointer w-[25%] text-center py-3 rounded-md border-b border-r border-white/30 text-darkGreen ${
                activeHeader === header ? "bg-[#CFF1E6] " : "bg-white "
              } `}
            >
              {header}
            </div>
          ))}
        </div> */}
          {activeHeader === "Active" &&
            (activeRental ? (
              <>
                <div className="flex flex-wrap justify-end items-end gap-5 ml-auto w-full">
                  <RentalChat
                    lessorId={activeRental.car.lessor.id}
                    lesseeId={activeRental.lessee.id}
                    rentalID={activeRental.id}
                  />
                  <button
                    className={`flex gap-2 items-center py-[11px] w-[200px] justify-center border-none rounded-lg text-white font-bold text-[12px] leading-[150%] ${
                      tripEndsToday ? "bg-midGreen" : " bg-red-600"
                    } `}
                    onClick={() => setShowEndTripModal(true)}
                  >
                    <TiCancelOutline className=" text-white text-[24px]" />
                    Return Vehicle
                  </button>
                </div>
                <div className="w-full flex flex-col-reverse lg:flex-row justify-between items-center">
                  <div
                    className=" w-[90%] mx-auto  lg:w-[48%] h-[500px] rounded-lg "
                    id="mapDiv"
                  ></div>
                  <div className=" w-[90%] mx-auto lg:w-[48%] bg-white px-6 py-11 flex flex-col gap-7">
                    <p className=" font-Inter font-medium leading-6 text-[#3D475C]">
                      Active Rentals
                    </p>
                    <main className="flex flex-col md:flex-row gap-2 items-center">
                      <section className="flex flex-col gap-3">
                        <div className="flex flex-col md:flex-row gap-3 items-center">
                          <img
                            src={ipfsGatewayImage(image)}
                            alt=""
                            className=" w-[82px] h-[42px] object-cover rounded-md "
                          />
                          <div className="flex flex-col gap-3">
                            <p className=" text-[#1D3A70] font-Roboto font-bold leading-4 text-[12px] ">
                              Booking ID: {activeRental?.id}
                            </p>
                            <div className=" flex flex-col gap-2">
                              <p className=" text-lightGreyText font-Roboto font-normal leading-4 text-[1opx] ">
                                From:{" "}
                                {formatDateAndTimeFromISO(
                                  activeRental?.rentalStartDatetime
                                )}
                              </p>
                              <p className=" text-lightGreyText font-Roboto font-normal leading-4 text-[1opx] ">
                                To:{" "}
                                {formatDateAndTimeFromISO(
                                  activeRental?.rentalEndDatetime
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className=" bg-[#F4F5F7] rounded-lg p-5 flex flex-col items-center gap-6">
                          <div className="flex flex-col items-center">
                            <img src={proximity} alt="" />
                            <p className=" font-Poppins text-black font-semibold text-[16px] leading-normal">
                              Proximity Unlock
                            </p>
                          </div>
                          <p className=" font-Poppins text-black text-center leading-normal font-normal">
                            Get close to the vehicle, and the Unlock button will
                            be enabled
                          </p>
                          <div className="flex gap-2">
                            <button
                              disabled={!vehicleFound}
                              onClick={() => {
                                unlockVehicle({
                                  variables: {
                                    data: {
                                      vehicleId:
                                        activeRental?.car?.smartCarVehicleId,
                                    },
                                  },
                                });
                              }}
                              className={`font-Poppins rounded-lg p-4 text-white text-center font-normal text-[12px] leading-normal ${
                                vehicleFound ? "bg-midGreen" : "bg-midGreen/70"
                              }`}
                            >
                              Unlock Vehicle
                            </button>
                            <button
                              onClick={() => {
                                lockVehicle({
                                  variables: {
                                    data: {
                                      vehicleId:
                                        activeRental?.car?.smartCarVehicleId,
                                    },
                                  },
                                });
                              }}
                              disabled={!vehicleFound}
                              className={`font-Poppins rounded-lg p-4 text-white text-center font-normal text-[12px] leading-normal ${
                                vehicleFound ? "bg-midGreen" : "bg-midGreen/70"
                              }`}
                            >
                              Lock Vehicle
                            </button>
                          </div>
                        </div>
                      </section>
                      <section className=" hidden md:flex flex-col gap-6 ">
                        <div className="flex flex-col gap-3">
                          <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                            Return Location
                            <span className=" tet-[13px] font-semibold leading-5">
                              {vehicleLocation as string}
                            </span>
                          </p>
                        </div>
                        <div className="flex flex-col gap-3">
                          <h1 className=" font-Jakarta font-semibold text-[9px]  uppercase leading-4">
                            FEATURES
                          </h1>
                          <div className="flex flex-col gap-4 ">
                            <div className=" flex gap-7">
                              <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                                Model
                                <span className=" tet-[13px] font-semibold leading-5">
                                  {activeRental?.car?.make}{" "}
                                  {activeRental?.car?.model}
                                </span>
                              </p>
                              <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                                Color
                                <span className=" tet-[13px] font-semibold leading-5">
                                  {activeRental.car?.color}
                                </span>
                              </p>
                              <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                                Capacity
                                <span className=" tet-[13px] font-semibold leading-5">
                                  {activeRental.car?.capacity} people
                                </span>
                              </p>
                            </div>
                            <div className=" flex gap-7">
                              <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                                Plate Number
                                <span className=" tet-[13px] font-semibold leading-5">
                                  {activeRental.car?.vehiclePlateNumber}
                                </span>
                              </p>
                              <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                                Mileage per charge
                                <span className=" tet-[13px] font-semibold leading-5">
                                  {activeRental.car?.millagePerCharge}km
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </section>
                    </main>
                  </div>
                </div>
              </>
            ) : readyRental ? (
              <ActiveRental rentalId={readyRental.id} />
            ) : (
              <div className="w-full py-60 items-center justify-center">
                <h1 className=" text-midGreen text-[30px] font-Poppins text-center leading-10 m-auto  ">
                  You have no {activeHeader.toLowerCase()} trip
                </h1>
              </div>
            ))}

          {activeHeader === "Booked" &&
            (bookedRental?.length ? (
              <div className="flex flex-wrap gap-5 w-full">
                {bookedRental.map((rental, index) => (
                  <div className=" " key={index}>
                    <RentalCard
                      rental={rental}
                      index={index}
                      refetch={rentalRefetch}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full py-60 items-center justify-center">
                <h1 className=" text-midGreen text-[30px] font-Poppins text-center leading-10 m-auto  ">
                  You have no {activeHeader.toLowerCase()} trip
                </h1>
              </div>
            ))}

          {/* {activeHeader === "History" &&
          (completedRental?.length ? (
            <div className="flex flex-wrap justify-between">
              {completedRental.map((rental, index) => (
                <div className="w-[80%] md:w-[45%] " key={index}>
                  <RentalCard rental={rental} index={index} />
                </div>
              ))}
            </div>
          ) : (
            <div className="w-full py-60 items-center justify-center">
              <h1 className=" text-midGreen text-[30px] font-Poppins text-center leading-10 m-auto  ">
                You have no {activeHeader.toLowerCase()} trip
              </h1>
            </div>
          ))} */}

          {activeHeader === "History" &&
            (allRental?.length ? (
              <div className="flex flex-wrap gap-5 w-full ">
                {allRental.map((rental, index) => (
                  <div className=" " key={index}>
                    <RentalCard
                      rental={rental}
                      index={index}
                      refetch={rentalRefetch}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full py-60 items-center justify-center">
                <h1 className=" text-midGreen text-[30px] font-Poppins text-center leading-10 m-auto  ">
                  You have no {activeHeader.toLowerCase()} trip
                </h1>
              </div>
            ))}
        </div>
        {showEndTripModal && (
          <div
            className="fixed z-10 inset-0 overflow-y-auto"
            // ref={paymentOptionModal}
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <div
                className="fixed inset-0 transition-opacity"
                aria-hidden="true"
              >
                <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>

              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>

              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center flex flex-col gap-7">
                      <CiWarning
                        className={`h-[100px] w-[100px] rounded-full mx-auto text-white p-2 ${
                          tripEndsToday ? "bg-midGreen" : "bg-red-500"
                        }`}
                      />
                      <div className="mt-2">
                        <p className="text-sm text-gray-500 text-center">
                          Are you sure you want to end the trip now? Your trip
                          is scheduled to end at{" "}
                          {new Date(
                            activeRental?.rentalEndDatetime as string
                          ).toDateString()}
                          ,{" "}
                          {new Date(
                            activeRental?.rentalEndDatetime as string
                          ).getHours()}
                          :
                          {new Date(
                            activeRental?.rentalEndDatetime as string
                          ).getMinutes()}
                        </p>
                        <div className="mt-4 flex gap-3">
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-midGreen text-base font-medium text-white hover:bg-midGreen focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-midGreen sm:text-sm"
                            onClick={() => {
                              setShowEndTripModal(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
                            onClick={() => {
                              setShowEndTripModal(false);
                              navigate(
                                `/vehicles/rental/return/${activeRental?.id}`
                              );
                            }}
                          >
                            End Trip
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => {
                    setShowEndTripModal(false);
                  }}
                >
                  Close
                </button>
              </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Trips;
